export default __webpack_public_path__ + "static/media/esrp1.c10e71ab.svg";